<template>
  <v-col v-if="hasMetadata" class="px-1 py-1">
    <v-row
        v-for="(meta, index) in document.metadata || []"
        :key="index"
        class="text-left pl-2">
      <text-view
          v-if="meta.dataType === 'string'"
          multiline
          :display="document.data[meta.propertyName]"
          :label="meta.description" />
      <date-view
          v-if="meta.dataType === 'dateTime'"
          multiline
          :display="document.data[meta.propertyName]"
          :label="meta.description" />
    </v-row>
  </v-col>
</template>

<script>
  import TextView from '@/components/reused/ui/TextView.vue'
  import DateView from '@/components/reused/ui/DateView.vue'

  export default {
    components: {
      TextView,
      DateView
    },
    props: {
      document: {
        type: Object,
        required: true,
        default: () => {
          return {
            metadata: [],
            data: {}
          }
        }
      }
    },
    computed: {
      hasMetadata () {
        return this.document.metadata?.length > 0 && this.document.data
      }
    }
  }
</script>
